export function listStatesProvinces() {
    const $list_states_provinces = $('.list-states-provinces > li');

    $list_states_provinces.on('click', '.h5', function () {
        if (window.innerWidth < 1200) {
            let $this = $(this);
            $this.parent().toggleClass('active').find('.state-info').slideToggle();
        }
    });

    if (arr_states.length) {
        $('.map-states > g').each((index, el) => {
            let activeStates = el.getAttribute('id');

            if ($.inArray(activeStates, arr_states) !== -1) {
                $(el).addClass('active-state');
            }
        });

        $('.active-state').on('click', function () {
            $(this).addClass('active').siblings().removeClass('active');
            let activeStates = $(this).attr('id');

            $list_states_provinces.removeClass('show').each((index, el) => {
                let state = el.getAttribute('data-state');
                if (state === activeStates) {
                    $(el).addClass('show');
                }
            });
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/list-states-provinces.js